import { useSelector } from "react-redux";

import { selectCurrentUserPermissions } from "../store/auth.slice";

export function useCurrentUserPermissions() {
  return useSelector(selectCurrentUserPermissions);
}
